module.exports = __webpack_public_path__ + "static/media/free.6cabadb8.png";